import { useEffect, useState } from "react";
import { Mail, Phone, MapPin, Building2 } from "lucide-react";
import { api } from "@/lib/api";

const Row = ({ Icon, label, children, testid }) => (
  <div className="flex gap-4 border-t asv-line py-5" data-testid={testid}>
    <span className="asv-accent-bg grid h-10 w-10 shrink-0 place-items-center rounded-full"><Icon className="h-5 w-5" /></span>
    <div className="min-w-0"><p className="asv-muted text-xs font-bold uppercase tracking-wide">{label}</p><div className="mt-1 break-words font-semibold">{children}</div></div>
  </div>
);

export default function AsvContact() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/asv/config").then((r) => setS(r.data.site)).catch(() => setS({})); }, []);
  if (!s) return <div className="asv-card mt-10 h-72 animate-pulse" />;
  return (
    <div className="mx-auto max-w-3xl pt-10" data-testid="asv-contact">
      <h1 className="asv-display text-4xl font-extrabold sm:text-5xl">Contact us</h1>
      <p className="asv-muted mt-3 max-w-xl" data-testid="contact-description">{s.short_description || "Questions about a booking, a refund or listing your venue? Get in touch and we'll help."}</p>
      <div className="asv-card mt-8 px-6 pb-1">
        {s.company_name && <Row Icon={Building2} label="Company" testid="contact-company"><p>{s.company_name}</p>{s.company_reg && <p className="asv-muted text-sm font-normal">Company Registration No. {s.company_reg}</p>}</Row>}
        {s.email && <Row Icon={Mail} label="Email" testid="contact-email"><a href={`mailto:${s.email}`} className="hover:underline">{s.email}</a></Row>}
        {s.phone && <Row Icon={Phone} label="Phone" testid="contact-phone"><a href={`tel:${s.phone.replace(/\s/g, "")}`} className="hover:underline">{s.phone}</a></Row>}
        {s.address && <Row Icon={MapPin} label="Address" testid="contact-address"><p className="whitespace-pre-line">{s.address}</p>
          <a href={s.map_url || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(s.address)}`} target="_blank" rel="noreferrer" className="asv-accent mt-1 inline-block text-sm" data-testid="contact-map-link">Open in Google Maps</a></Row>}
      </div>
      <p className="asv-muted mt-6 text-sm">For booking questions, please include your order number so we can help faster.</p>
    </div>
  );
}
